import APICall from "../utils/APICall";

export default class ThirdPartyServices {
    
    static ThirdPartyUsers = async (data) => {
        return await APICall(`/api/ThirdPartyOrganization/admin/on-board`, "POST", data)
    }

    static ListThirdPartyUsers = async () => {
        return await APICall(`/api/ThirdPartyOrganization/admin/list-organizations`, "GET")
    }
}